// JS for block-specific behavior only
console.log('res three column stat block loaded');